import axios from 'axios';
import { AdminUrls } from '../network/config';

const apiCall = {
  getCpdYear() {
    return axios.get(AdminUrls.ADMIN.GETCPDYEARS, {
      method: 'GET',
      withCredentials: true,
      credentials: 'include',
      headers: {
        Authorization: 'bearer ' + localStorage.Access_Token,
        'Content-Type': 'application/json',
      },
    });
  },
};

export { apiCall };
